import type { OrganizationStructureTabId } from "./types.ts";

export const TAB_DEPARTMENTS: OrganizationStructureTabId = "departments";
export const TAB_DESIGNATIONS: OrganizationStructureTabId = "designations";
export const TAB_ROLES: OrganizationStructureTabId = "roles";

export const ORGANIZATION_STRUCTURE_TABS: {
  id: OrganizationStructureTabId;
  label: string;
}[] = [
  { id: TAB_DEPARTMENTS, label: "Departments" },
  { id: TAB_DESIGNATIONS, label: "Designations" },
  { id: TAB_ROLES, label: "Roles" },
];

export const DEFAULT_PAGE_SIZE = 10;

export const DISABLED_ROLE_NAME = "EMPLOYEE";
